var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "step-3" }, [
    _c("div", { staticClass: "header" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "title" }, [
        _vm._v(
          "\n      " + _vm._s(_vm.$t("booking.reserveSuccess")) + "\n    "
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "details" }, [
      _c("div", { staticClass: "date" }, [
        _vm._v("\n      " + _vm._s(_vm.details.date) + "\n    "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "time" }, [
        _vm._v("\n      " + _vm._s(_vm.details.time) + "\n    "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "timezone" }, [
        _c("i", { staticClass: "isif isif-globe" }),
        _vm._v(_vm._s(_vm.bookings.timezone) + "\n    "),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "description" }, [
      _vm._v(
        "\n    " + _vm._s(_vm.$t("booking.thanksUser")) + " " + _vm._s(_vm.name)
      ),
      _c("br"),
      _vm._v("\n    " + _vm._s(_vm.$t("booking.confirmingEmail")) + "\n  "),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon" }, [
      _c("i", { staticClass: "isif isif-check" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }